import { Box, Typography, TextField, InputAdornment, Button } from "@mui/material";
import { useState, useCallback, useRef } from "react";
import AcronymTable from "./AcronymTable";
import AcronymFormDialogContainer from "./AcronymFormDialogContainer";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

const AcronymContainer = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const tableRef = useRef<any>(null);

  const handleSearch = useCallback(() => {
    if (tableRef.current && tableRef.current.performSearch) {
      tableRef.current.performSearch(searchQuery);
    }
  }, [searchQuery]);

  const handleCreate = useCallback(() => {
    if (tableRef.current && tableRef.current.performCreate) {
      tableRef.current.performCreate();
    }
  }, []);

  return (
    <>
      <Box className='acronym-container'>
        <Box className='acronym-header'>
          <Box>
            <Typography variant="h4" className='acronym-title'>
              Acronym Management
            </Typography>
            <Typography variant="body1" className='acronym-subtitle'>
              Manage abbreviations and their full forms.
            </Typography>
          </Box>
          <Box className='acronym-header-actions'>
            <TextField
              className='acronym-search-input'
              placeholder="Search acronyms..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ flex: 1, maxWidth: '300px' }}
            />
            <Button
              variant='contained'
              className='create-acronym-button'
              startIcon={<AddIcon />}
              onClick={handleCreate}
            >
              Create
            </Button>
          </Box>
        </Box>
        <AcronymTable ref={tableRef} />
      </Box>      
      <AcronymFormDialogContainer/>
    </>
  );
};

export default AcronymContainer;

